export const THUMBNAIL_DIMENSIONS = "?width=50&height=38&format=png";
export const LARGE_THUMBNAIL_DIMENSIONS = "?width=160&height=120&format=png";
export const HD_THUMBNAIL_DIMENSIONS = "?width=1920&height=960&format=png";
